import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { ErpPermissionFragmentDoc } from './erpPermission';
export type RoleWithPermissionsFragment = { __typename?: 'Role', id: number, name: string, label?: string | null, erpPermissions: Array<{ __typename?: 'ErpPermission', id: number, group: string, action: string, name: string, label?: string | null }> };

export const RoleWithPermissionsFragmentDoc = gql`
    fragment roleWithPermissions on Role {
  id
  name
  label
  erpPermissions {
    ...erpPermission
  }
}
    ${ErpPermissionFragmentDoc}`;